import { AxiosRequestConfig } from 'axios';
import { axiosInstance, saveFile } from '@fides/fides-react-components';
import { API_ENDPOINTS } from '../constants/ApiEndpoints';

export async function downloadFile(
  config: AxiosRequestConfig,
  fileName: string
) {
  return axiosInstance({
    method: 'GET',
    responseType: 'blob',
    ...config,
  }).then((response) => saveFile(response.data as BlobPart, fileName));
}

export const getApplications = (portalUrl: string) => axiosInstance({
  url: portalUrl + API_ENDPOINTS.fidesPortal.applications,
  method: 'POST'
}).then(resp => resp.data);
